import { Button, Text } from '@user-portal/wikr-components';
import React from 'react';

import Modal from 'components/Modal';

import smile from 'assets/img/webp/smile.webp';

import { IRestoreSubscriptionModal } from './types';

import * as S from './styled';

const RestoreSubscriptionModal = ({ onSubmit, onClose, onDiscard, trackLoad, captions }: IRestoreSubscriptionModal) => {
    const { title, description, submitButton, discardButton } = captions;

    return (
        <Modal
            isOpen
            onClose={onClose}
            withCloseButton
            closeOnOverlayClick
            trackLoad={trackLoad}
            paddingX={16}
            paddingY={16}
            dataLocatorContainer="updatingSubscriptionPlanModal"
            dataLocatorCloseButton="updatingSubscriptionPlanCloseButton"
        >
            <div data-locator="cancelSubModal">
                <S.Img src={smile} alt="smile face" width={48} height={48} />
                <Text type="h5" center mb={12}>
                    {title}
                </Text>
                {description && (
                    <Text center medium mb={24}>
                        {description}
                    </Text>
                )}
                <Button
                    onClick={onSubmit}
                    dataLocator="updatingSubscriptionPlanContinueButton"
                    mb={discardButton ? 20 : 0}
                >
                    {submitButton}
                </Button>

                {onDiscard && discardButton && (
                    <S.ConfirmButton dataLocator="keepSubBtn" size="medium" textColor="action-main" onClick={onDiscard}>
                        {discardButton}
                    </S.ConfirmButton>
                )}
            </div>
        </Modal>
    );
};

export default RestoreSubscriptionModal;
